/*eslint-disable*/
import permissions from '@/config/permissions'

export default {
    install(Vue) {
        Vue.prototype.$can = function(operation, type) {
            let user = this.$store.state.auth.user;
            if (user.isSuperadmin) {
                return true;
            }
            let flag = false;
            for (let i = 0; i < permissions[operation][user.type].length; i++) {
                if (permissions[operation][user.type][i].type === type) {
                    flag = true;
                    break;
                }
            }
            return flag;
        };
    }
}
